import { Link } from "react-router-dom";
import { MapPin, Users, BedDouble, Bath, PartyPopper, BadgePercent } from "lucide-react";
import { AMENITY_LABELS } from "@/lib/api";
import { Stars } from "./Stars";

export const PropertyCard = ({ p, index = 0 }) => (
  <Link to={`/rentals/${p.id}`} data-testid={`property-card-${p.id}`}
    className="group block card-lux rounded-3xl overflow-hidden lift animate-fade-up"
    style={{ animationDelay: `${index * 60}ms` }}>
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={p.hero} alt={p.name} loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-x-4 top-4 flex flex-col items-start gap-2">
        {p.event_type && (
          <span data-testid={`event-badge-${p.id}`}
            className="rounded-full bg-[#c9a86a] px-3 py-1 text-[11px] font-semibold text-ink shadow-sm">
            {p.event_type === "wedding" ? "Perfect for Weddings" : "Great for Gatherings"}
          </span>
        )}
        <div className="flex flex-wrap gap-2">
          {p.tags.filter((t) => t !== "events").slice(0, 3).map((t) => (
            <span key={t} className="glass rounded-full px-3 py-1 text-[11px] font-semibold text-ink">
              {AMENITY_LABELS[t]}
            </span>
          ))}
        </div>
      </div>
      <span className="absolute bottom-4 left-4 flex items-center gap-1 rounded-full bg-emerald-600/95 px-3 py-1 text-[11px] font-semibold text-white shadow-sm">
        <BadgePercent size={12} /> Save ~15% vs Airbnb
      </span>
    </div>
    <div className="p-5">
      <div className="mb-1 flex items-center justify-between gap-2">
        <h3 className="text-xl leading-tight text-ink">{p.name}</h3>
        <span className="flex shrink-0 items-center gap-1 text-sm text-ink">
          {p.rating
            ? <><Stars value={p.rating} size={13} /> <span className="font-semibold">{p.rating}</span></>
            : <span className="rounded-full bg-cream px-2 py-0.5 text-[11px] font-semibold text-taupe">New</span>}
        </span>
      </div>
      <p className="mb-4 flex items-center gap-1 text-sm text-muted-foreground">
        <MapPin size={14} strokeWidth={1.5} /> {p.city}, {p.state}
      </p>
      <div className="flex items-center gap-4 text-sm text-taupe">
        <span className="flex items-center gap-1"><BedDouble size={15} strokeWidth={1.5} /> {p.bedrooms}</span>
        <span className="flex items-center gap-1"><Bath size={15} strokeWidth={1.5} /> {p.bathrooms}</span>
        <span className="flex items-center gap-1"><Users size={15} strokeWidth={1.5} /> {p.max_guests}</span>
      </div>
      {p.event_type && (
        <p data-testid={`event-fit-${p.id}`} className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-camel">
          <PartyPopper size={13} strokeWidth={1.75} />
          Sleeps {p.max_guests}{p.tags.filter((t) => t !== "events").slice(0, 2).map((t) => AMENITY_LABELS[t]).filter(Boolean).map((l) => ` · ${l}`).join("")}
        </p>
      )}
    </div>
  </Link>
);
